import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import Cookies from "js-cookie";
import gajiPph21Service from "../../services/gajiPph21Service";

export const initialState = {
    loading_gaji_pph21: false,
    data_gaji_pph21: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataGajiPph21 = createAsyncThunk('gaji_pph21/data',async (data, { rejectWithValue }) => {
    try {
        const response = await gajiPph21Service.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('gaji_pph21/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await gajiPph21Service.data_import(localStorage.getItem(AUTH_TOKEN),data)
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('gaji_pph21/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await gajiPph21Service.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('gaji_pph21/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await gajiPph21Service.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})


export const gajiPph21Slice = createSlice({
    name: 'gaji_pph21',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_gaji_pph21 = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataGajiPph21.fulfilled, (state, action) => {
                state.loading_gaji_pph21 = false
                state.data_gaji_pph21 = action.payload??[]
            })
            .addCase(getDataGajiPph21.pending, (state) => {
                state.loading_gaji_pph21 = true
            })
            .addCase(getDataGajiPph21.rejected, (state, action) => {
                state.loading_gaji_pph21 = false
                state.data_gaji_pph21 = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_gaji_pph21 = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_gaji_pph21 = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_gaji_pph21 = false
                state.data_import = action.payload
            })

    },
})

export const {
    showLoading,
} = gajiPph21Slice.actions

export default gajiPph21Slice.reducer
